<template>
    <div class="modal-out">
        <div class="modal">
            <div class="modal-header">
                <div class="title">修改</div>
                <button type="button" class="btn-close" @click="closeSelf">X</button>
            </div>
            <div class="modal-body">
                <el-form :model="editForm" :rules="rules" ref="editForm">
                  <el-row>
                    <el-col :span="12" class="item">
                      <el-form-item label="机构" required prop="institutionCode">
                        <el-select v-model="editForm.institutionCode" placeholder="请选择机构" style="width: 100%">
                          <el-option
                              v-for="item in arr_ins"
                              :key="item.institutionCode"
                              :label="item.userName"
                              :value="item.institutionCode">
                          </el-option>
                        </el-select>
                      </el-form-item>
                    </el-col>
                      <el-col :span="12" class="item">
                          <el-form-item label="名称" required prop="name">
                              <el-input v-model="editForm.name" placeholder="请输入名称"></el-input>
                          </el-form-item>
                      </el-col>
                      <el-col :span="12" class="item">
                          <el-form-item label="排序" required prop="sort">
                              <el-input v-model.number="editForm.sort" placeholder="请输入排序"></el-input>
                          </el-form-item>
                      </el-col>
                      <el-col :span="12" class="item">
                          <el-form-item label="状态" required prop="status">
                              <el-select v-model="editForm.status" placeholder="请选择状态" @change="changeStatus" style="width:100%">
                                  <el-option
                                          v-for="item in status2"
                                          :key="item.value"
                                          :label="item.label"
                                          :value="item.value">
                                  </el-option>
                              </el-select>
                          </el-form-item>
                      </el-col>
                  </el-row>
                </el-form>
            </div>
            <div class="modal-footer">
                <el-button :loading="loading" type="primary" @click="confirm('editForm')">修改</el-button>
            </div>
        </div>
    </div>
</template>

<script>

    import {timeStr} from "@/common/times";
    import {hex_md5} from "@/common/Base64MD5";
    import {getStaffCode} from "@/utils/auth";


    export default {
        name: 'Edit',
      props:['arr_ins'],
        data() {
            return {
                loading: false,
                editForm:{
                    timeStr:timeStr,
                    sign:'',
                    staffCode:getStaffCode(),
                  institutionCode:'',
                    name:'',
                    waresTypeCode:'',
                    sort:'',
                    status:0
                },

                status2: [{
                    value: 0,
                    label: '正常'
                }, {
                    value: 1,
                    label: '被禁用'
                }],

                rules:{
                    name:[
                        { required: true, message: '请输入名称', trigger: 'blur' },
                    ],
                    sort:[
                        { required: true, message: '请输入排序', trigger: 'blur' },
                        { type: 'number', message: '排序必须为数字值'}
                    ],
                  institutionCode:[
                    { required: true, message: '请选择机构', trigger: 'blur' },
                  ],

                }

            }
        },

        methods: {

            init(row){

                this.editForm.waresTypeCode = row.waresTypeCode;
                this.editForm.name = row.name;
                this.editForm.sort = row.sort;
                this.editForm.status = row.status;
                this.editForm.institutionCode = row.institutionCode;
            },

            closeSelf() {
                this.$emit("closeEdit");
            },

            confirm(editForm){
                this.$refs[editForm].validate((valid) => {
                    if(valid){
                        this.addSubmit();
                    }else {
                        console.log('error submit!!');
                        return false;
                    }
                })


            },

            addSubmit(){

                if(this.loading){
                    return;
                }else{
                    this.loading = true;
                }

                this.editForm.sign = hex_md5("timeStr=" + timeStr + "&key="+this.$signKey);

                this.$axios({
                    method: 'post',
                    url: this.$shopUrl+"WaresType/GovEditIns",
                    data: this.editForm
                }).then((response) => {
                        this.loading = false;

                        if (response.data.error == 0) {
                            this.$emit("closeEdit");
                            this.$emit("getList");
                        }else if(response.data.error == 1){
                            this.$message({type: 'info', message: response.data.message});
                        }
                    })
            },

        }
    }


</script>


<style lang="scss" scoped>


</style>
